<script>
  import { snacks } from '../store/snacks';
  import SnackItem from './snack-item.svelte';
</script>

{#if $snacks.length}
  <div class="fixed bottom-8 left-2 right-2 z-[60] md:left-auto md:right-8 md:w-min">
    <ul class="flex flex-col gap-4">
      {#each $snacks as snack (snack.id)}
        <SnackItem {snack} />
      {/each}
    </ul>
  </div>
{/if}
